<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { HTMLInputAttributes } from 'svelte/elements';

  interface Props extends Omit<HTMLInputAttributes, 'value' | 'prefix'> {
    value?: string | number | null;
    invalid?: boolean;
    prefix?: Snippet | string;
    suffix?: Snippet | string;
    el?: HTMLInputElement | null;
  }
  let { value = $bindable(''), invalid = false, prefix, suffix, el = $bindable(null), class: cls = '', ...rest }: Props = $props();
</script>

{#if prefix || suffix}
  <div class="affix {cls}" class:invalid>
    {#if prefix}<span class="pre">{#if typeof prefix === 'string'}{prefix}{:else}{@render prefix()}{/if}</span>{/if}
    <input class="control inner" bind:value bind:this={el} aria-invalid={invalid || undefined} {...rest} />
    {#if suffix}<span class="suf">{#if typeof suffix === 'string'}{suffix}{:else}{@render suffix()}{/if}</span>{/if}
  </div>
{:else}
  <input class="control {cls}" class:invalid bind:value bind:this={el} aria-invalid={invalid || undefined} {...rest} />
{/if}

<style>
  .affix {
    display: flex;
    align-items: center;
    height: var(--control-h);
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    background: var(--surface);
    transition: border-color var(--dur), box-shadow var(--dur);
    min-width: 0;
  }
  .affix:hover { border-color: var(--border-strong); }
  .affix:focus-within { border-color: var(--brand); box-shadow: var(--ring); }
  .affix.invalid { border-color: var(--danger); }
  /* The inner input drops the .control chrome; .affix .inner outranks .control:focus. */
  .affix .inner { border: 0; box-shadow: none; background: transparent; height: 100%; padding: 0 var(--space-2_5); }
  .pre, .suf { display: inline-flex; align-items: center; color: var(--text-3); font-size: var(--text-sm); padding: 0 0 0 var(--space-3); flex-shrink: 0; }
  .suf { padding: 0 var(--space-3) 0 0; }
  .pre :global(svg), .suf :global(svg) { width: var(--icon-md); height: var(--icon-md); }
</style>
